import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

const loader = lazyForPaint(() => import(/* webpackChunkName: "user-profile" */ './hocs'));
export const UserProfile = withAsync({
    loader,
});
